import { UserRulesPickerController } from './user-rules-picker.controller';
import { UserRulesPickerProps } from './user-rules-picker.model';

export const UserRulesPicker = (props: UserRulesPickerProps) => {
  return <UserRulesPickerController {...props} />;
};
